import { render, staticRenderFns } from "./CardStats.vue?vue&type=template&id=1dbed6dd&"
import script from "./CardStats.vue?vue&type=script&lang=js&"
export * from "./CardStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports